var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CRow',[_c('CCol',[_c('div',{staticClass:"bg-warning"},[_c('div',{attrs:{"id":"demo"}},[_c('vue-metamask',{attrs:{"userMessage":"msg"},on:{"onComplete":_vm.onComplete}})],1)])])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }